import { hillo } from 'hillo'
import IKDataEntity from '@/plugins/EntityFrameWork/IKDataEntity'
import GlobalConfig from '@/model/global/GlobalSettings'
import { cloudV2Url } from '@/model/dataLayer/api/SaaS/SaaSUtils'
import dayjs from 'dayjs'

const voucherPath = 'membership/voucher/'
const entity = {
  name: {},
  discountStr: {},
  usedAt: {},
  usedOrderDeviceId: {},
  usedOrderId: {},
  createTimestamp: {}
}
const config = {
  load: async function () {
    return (await hillo.get(cloudV2Url + voucherPath + 'voucher-record/' + GlobalConfig.blId, {})).map(it => {
      it.name = it.voucherInfo.displayInfo.name
      it.discountStr = it.voucherInfo.discountStr
      return it
    })
  }
}

export default IKDataEntity.ModelFactory(entity, config)

const userDetail = 'membership/user/'

export async function getUserDetailMemberInfo (userId, deviceId) {
  return (await hillo.get(cloudV2Url + userDetail + 'user-detail/' + userId + '/device/' + deviceId))
}

export function ageDisplay (age) {
  if (!age) {
    return '神秘莫测'
  } else {
    const currentAge = dayjs().diff(dayjs(age), 'year')
    if (currentAge < 10) return 0
    return Math.floor(currentAge / 10) * 10
  }
}
